import { pick } from 'lodash/fp';
import { ActionObject } from '../actions/actionTypes';

type ActionLogObject = {
    action: Partial<{
        ids: string[];
        id: string;
        type: string;
        user: {
            _id: string;
        };
        deviceId: string;
        sessionId: string;
        channels: string[] | string;
        remote: boolean;
        source: string;
        bufferFlush: boolean;
        attempt: number;
    }>;
};

/**
 * Used to prepare action for logging, by including generically necessary information and
 * filtering out sensitive data.
 *
 * NOTE: This was moved from server/common/loggerUtils.ts so it can be shared client & server side.
 * Behaviour has been kept identical (including the use of pick with 'user._id').
 */
export const prepareActionForLogging = (action: ActionObject): ActionLogObject => ({
    action: {
        ...pick(
            [
                'type',
                'id',
                'ids',
                'user._id',
                'deviceId',
                'sessionId',
                'channels',
                'remote',
                'source',
                'bufferFlush',
                'attempt',
            ],
            action,
        ),
        ids: action.updates?.map(({ id }) => id),
    },
});

export type { ActionLogObject };
